import { styled, keyframes } from "styled-components";

const fadeIn = keyframes`
  from { opacity: 0; transform: translateY(20px); }
  to { opacity: 1; transform: translateY(0); }
`;

const imageFade = keyframes`
  from { opacity: 0; transform: scale(0.95); }
  to { opacity: 1; transform: scale(1); }
`;

export const BannerWrapper = styled.div`
  height: 650px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 4rem var(--hPadding);
  position: relative;
  overflow: hidden;
  background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);

  .gallery-wrapper {
    flex: 1;
    display: flex;
    height: 100%;
    justify-content: center;
    align-items: center;
    gap: 2rem;
    padding: 2rem;
    z-index: 1;
    animation: ${imageFade} 1s ease-out forwards;

    .image-container {
      flex: 1;
      height: 100%;
      margin: 0 !important;
      display: flex;
      justify-content: center;
      align-items: center;
      max-width: 50%;

      img {
        width: 100%;
        height: 100%;
        object-fit: contain;
        filter: drop-shadow(0 30px 60px rgba(0,0,0,0.12));
      }
    }
  }

  &.photo-only {
    background: transparent;
    padding: 0;
    justify-content: center;

    .gallery-wrapper {
      padding: 2rem;
      gap: 2rem;
      width: 100%;
      max-width: 1200px;
      margin: 0 auto;
      
      .image-container {
        max-width: 48%;
        height: 100%;
        
        img {
          object-fit: contain; /* Contain is safer for products */
        }
      }
    }
  }

  .text-container {
    flex: 1;
    max-width: 550px;
// ... (rest remains same)
    z-index: 2;
    padding: 3rem;
    background: rgba(255, 255, 255, 0.7);
    backdrop-filter: blur(12px);
    -webkit-backdrop-filter: blur(12px);
    border: 1px solid rgba(255, 255, 255, 0.5);
    border-radius: 24px;
    box-shadow: 0 20px 40px rgba(0, 0, 0, 0.05);
    animation: ${fadeIn} 0.8s ease-out forwards;

    h1 {
      font-size: 3.5rem;
      font-weight: 900;
      line-height: 1.1;
      color: var(--blue);
      margin-bottom: 1.5rem;
      letter-spacing: -1.5px;
    }

    p {
      font-size: 1.125rem;
      line-height: 1.6;
      color: #4a5568;
      margin-bottom: 2.5rem;
      font-weight: 400;
    }

    .btn {
      display: inline-flex;
      align-items: center;
      padding: 1rem 2.5rem;
      background: var(--yellow);
      color: var(--dark);
      font-weight: 700;
      border-radius: 12px;
      transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
      box-shadow: 0 10px 15px -3px rgba(255, 197, 16, 0.3);

      &:hover {
        transform: translateY(-2px);
        box-shadow: 0 20px 25px -5px rgba(255, 197, 16, 0.4);
        background: #f0b800;
      }
    }
  }

  .image-container {
    flex: 1;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 1;
    margin-left: 4rem;
    animation: ${imageFade} 1s ease-out forwards;

    img {
      max-width: 100%;
      max-height: 100%;
      object-fit: contain;
      filter: drop-shadow(0 30px 60px rgba(0,0,0,0.12));
      transition: transform 0.5s ease;

      &:hover {
        transform: scale(1.02);
      }
    }
  }

  @media only screen and (max-width: 1150px) {
    height: auto;
    min-height: auto;
    flex-direction: column;
    padding: 3rem 1.5rem;
    text-align: center;

    .text-container {
      margin: 0 auto 2rem;
      padding: 1.5rem;
      max-width: 100%;
      order: 1;

      h1 {
        font-size: 1.75rem;
        letter-spacing: -0.5px;
        margin-bottom: 1rem;
      }

      p {
        font-size: 1rem;
        margin-bottom: 1.5rem;
      }
    }

    .image-container {
      margin-left: 0;
      order: 2;
      
      img {
        max-height: 300px;
      }
    }

    .gallery-wrapper {
      flex-direction: column;
      padding: 1rem;
      gap: 1rem;

      .image-container {
        max-width: 100%;
        height: 250px;
      }
    }
  }

  @media only screen and (max-width: 500px) {
    padding: 2rem 1rem;
    
    .text-container {
      padding: 1.25rem;

      h1 {
        font-size: 1.5rem;
      }
    }
  }
`;
